<form [formGroup]="privateWorkshopForm">
  @if (loading) {
    <div class="loading-indicator">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <div class="pagehd">Private Workshop Access Lists</div>
  <div class="ui-g workshop-header">
    <div class="ui-g-12 ui-md-12 ui-lg-12 title">Program</div>
    <div class="ui-g-12 ui-md-3 ui-lg-3">
      <p-select
        [options]="programtypes"
        placeholder="--Select Program--"
        optionLabel="programName"
        (onChange)="onProgramTypeSelect($event)">
      </p-select>
    </div>
    <div class="ui-g-12 ui-md-12 ui-lg-12 title">Workshop name</div>
    <div class="ui-g-12 ui-md-3 ui-lg-3">
      <p-select
        [options]="privateEngagementTypeList"
        placeholder="--Select Private workshop--"
        optionLabel="engagementType"
        formControlName="partnerWorkshopType"
        (onChange)="onWorkshopTypeSelect()">
      </p-select>
    </div>
  </div>
</form>
<app-upload-history
  #uploadHistory
  (refreshList)="onWorkshopTypeSelect()"></app-upload-history>
